import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/classes'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(grade) {
    return http.post(`${resource}`, grade)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(grade, uuid) {
    return http.put(`${resource}/${uuid}?_method=PUT`, grade)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
